import { Button, Link, Popover, PopoverSurface, PopoverTrigger, makeStyles, tokens } from '@fluentui/react-components';
import React from 'react';
import { Trans } from 'react-i18next';
import { AbtisConfig } from '../../abtis-config';
import { abtisAccentColorValueString, abtisAccentHoverColorValueString } from '../../styles';
import { Info24 } from '../shared/BundledIcons';

export const useClasses = makeStyles({
    root: {
        color: tokens.colorNeutralForeground1,
    },
    versionNumber: {
        textAlign: 'right',
    },
    sourceInfoLink: {
        color: abtisAccentColorValueString,
        '&:hover': {
            color: abtisAccentHoverColorValueString,
        },
    },
});

export const SourceInfo: React.FC = () => {
    const classes = useClasses();

    return (
        <Popover>
            <PopoverTrigger disableButtonEnhancement>
                <Button className={classes.root} icon={<Info24 />} appearance="transparent" />
            </PopoverTrigger>
            <PopoverSurface>
                <Trans
                    i18nKey="SourceInfo"
                    components={{
                        Link1: (
                            <Link
                                className={classes.sourceInfoLink}
                                href="https://github.com/microsoft/chat-copilot"
                                target="_blank"
                            >
                                Copilot Chat Sample Application
                            </Link>
                        ),
                        Link2: (
                            <Link
                                className={classes.sourceInfoLink}
                                href="https://raw.githubusercontent.com/microsoft/chat-copilot/main/LICENSE"
                                target="_blank"
                            >
                                MIT License
                            </Link>
                        ),
                        Link3: (
                            <Link
                                className={classes.sourceInfoLink}
                                href="https://www.abtis.de/agb-und-rechtliches"
                                target="_blank"
                            >
                                abtis.de
                            </Link>
                        ),
                    }}
                ></Trans>
                <br />
                <br />
                <div className={classes.versionNumber}>Version: {AbtisConfig.versionNumber}</div>
            </PopoverSurface>
        </Popover>
    );
};
